import { ActivatedRoute, Router } from '@angular/router';
import { CatalogueService } from 'app/components/catalogue/catalogue.service';
import { SessionService } from 'app/components/common/session/session.service';
import { MapsService } from 'app/components/maps/maps.service';
import { ExhitorsService } from 'app/components/exhitors/exhitors.service';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { UtilsService } from 'app/components/utils/utils.service';
import { DomSanitizer, SafeResourceUrl, Title } from '@angular/platform-browser';
import { OdsService } from 'app/components/ods/ods.service';
import { SearchService } from 'app/components/search/search.service';
import { TranslateService } from '@ngx-translate/core';
import { DetailsService } from 'app/components/details/details.service';
import { AnalyticsService } from 'app/components/analytics/analytics.service';
import { LoginService } from 'app/components/login/login.service';
import { Subscription } from 'rxjs';
import { CONSTANTS } from 'environments/common';

interface Product {
  name: string;
  description: string;
  image: string;
}

@Component({
  selector: 'app-card-detail',
  templateUrl: './card-detail.component.html',
  styleUrls: ['./card-detail.component.scss']
})
export class CardDetailComponent implements OnInit, OnDestroy {

  @Input() exhibitor: any;
  @Input() socialNetworks: any;
  //@Input() images: any[];
  //@Input() categories: any;
  ods: any[] = [];
  @Input() isOdsActive: boolean;
  @Input() mapsActive: boolean;
  @Input() videoEmbed: string;

  @Input() entityId: any;
  @Input() event: string;
  odsClass: string[] = [];
  catalogueProperties: any = {};

  type:string = "EXHIBITOR";

  loader: any = {
    count: 0
  };

  alertType: string = '';
  
  alertMessage: string = '';

  unifiedCategories: any = [];
  helpers: any;

  
  products: any[] = [];
  //categories: any[] = [];
  projection: any = {};
  images: any[] = [];
  socialNetwork: any[] = [];
  firaMaps: any[] = [];
  files: any[] = [];


  //revisado 

  sub;
  viewType: string = 'grid';

  isFavorite: boolean = false;
  countriesMap = {};
  searchConfig;

  exhibitorId;
  catalogueId;
  eventName;

  baseDataLoaded: boolean = false;
  categories:any = {};

  standData: any;

  

  currentSlideIndex: number = 0;
  private autoSlideInterval: any;
  private readonly AUTO_SLIDE_DELAY = 5000;

  private langChangeSubscription: Subscription;

  constructor(private exhitorsService:ExhitorsService, public catalogueService:CatalogueService, private mapsService:MapsService, 
    public sessionService: SessionService, private activatedRoute:ActivatedRoute, public utilsService:UtilsService, private sanitizer: DomSanitizer,
    private odsService:OdsService, private searchService:SearchService, private router:Router, public translateService: TranslateService,
    public detailsService:DetailsService, private titleService:Title, private analyticsService: AnalyticsService, public loginService: LoginService) {
      this.files = [];
      this.eventName = this.activatedRoute.snapshot.paramMap.get('event') || null;
      this.exhibitorId = this.activatedRoute.snapshot.paramMap.get('id') || null;
      this.catalogueId = this.activatedRoute.snapshot.paramMap.get('catalogueId') || null;

    }

  _api(transition, property){
    return this.utilsService._api(transition, property);
  }

  ngOnInit(): void {

    this.searchConfig = this.searchService.getSearchConfig();

    this.catalogueService.getDataProperties().subscribe(data => {
      this.catalogueProperties = data;
    });

    //this.odsClass = Array(this.ods.length).fill('ods_img_little');
    //entityId
    
    let getSocialNetworkIn = {
      event: this.eventName
    };
    
    let getPublishedProductsIn = {
      exhibitorId: this.exhibitorId 
    };
    
    let getCategoriesIn = {
      exhibitorId: this.exhibitorId 
    };
    
    let getProjectionIn = {
      exhibitorId: this.exhibitorId ,
      projection: 'detail'
    };
    
    
    let getImagesIn = {
      exhibitorId: this.exhibitorId 
    };

    let getFiraMapsIn = {
      id: this.exhibitorId ,
      event:  this.eventName
    };

    let getOdsActiveIn = {
      eventName:  this.eventName
    }
    
    let getOdsIn = {
      exhibitorId: this.exhibitorId 
    }

    let getCatalogueAndExhibitorIn = {
      catalogueId: this.catalogueId,
      exhibitorId: this.exhibitorId 
    }

    let getHierarchicalPropertiesIn = {
      catalogueId: this.catalogueId,
      exhibitorId: this.exhibitorId 
    }

    let getCountriesInUseIn = {
      catalogueId: this.catalogueId
    }

    this.getCatalogueAndExhibitor(getCatalogueAndExhibitorIn);
    this.getPublishedProducts(getPublishedProductsIn);
    this.getSocialNetwork(getSocialNetworkIn);
    this.getCategories(getCategoriesIn);
    this.getProjection(getProjectionIn);
    this.getImages(getImagesIn);
    this.getFiraMaps(getFiraMapsIn);
    this.getOdsActive(getOdsActiveIn);
    //if(this.odsActive){
      this.getOds(getOdsIn);
    //}

    this.getHierarchicalProperties(getHierarchicalPropertiesIn);
    this.getCountriesInUse(getCountriesInUseIn);

    this.prepareDataAndSendAnalytics();

    this.langChangeSubscription = this.translateService.onLangChange.subscribe(() => {
      this.products = this.sortProductsByCurrentLanguage([...this.products]);
    });

  }

  ngOnDestroy(): void {
    this.stopAutoSlide();
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe();
    }
    this.stopAutoSlide();
  }

  prepareDataAndSendAnalytics() {
      setTimeout(() => {
        this.products = this.products.map(product => ({
          ...product,
          exhibitorName: this.projection?.name,
          exhibitorId: this.exhibitorId,
          standLocation: this.projection?.standLocation
        }));
        if (this.products.length > 0) {
          this.analyticsService.sendViewItemList(this.products, 'product', 'detail');
        }
        this.analyticsService.sendViewItem(this.projection, 'exhibitor', this.unifiedCategories);
      }, 1000);
  }


  getPublishedProducts(getPublishedProductsIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.exhitorsService.getPublishedProducts(getPublishedProductsIn)
      .subscribe((data: object) => {
        this.getPublishedProductsOk(data);
      },
        error => {
          this.getPublishedProductsError(error);
        });

  }

  getPublishedProductsOk(data) {

    this.loader.count--;
    this.products = this.sortProductsByCurrentLanguage(data);

  }

  sortProductsByCurrentLanguage(products: any[]): any[] {
    const currentLang = this.translateService.currentLang;

    return products.sort((a, b) => {
      const nameA = this.getTranslatedName(a.translations, currentLang);
      const nameB = this.getTranslatedName(b.translations, currentLang);
      return nameA.localeCompare(nameB, currentLang);
    });
  }

  getTranslatedName(translations: any[], lang: string): string {
    if (!translations || translations.length === 0) {
      return '';
    }

    const translation = translations.find(t => t.language && t.language.includes(lang));
    if (translation && translation.name) {
      return translation.name;
    }

    return translations[0]?.name || '';
  }

  getPublishedProductsError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }


  getCategories(getCategoriesIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.exhitorsService.getCategories(getCategoriesIn)
      .subscribe((data: object) => {
        this.getCategoriesOk(data);
      },
        error => {
          this.getCategoriesError(error);
        });

  }

  getCategoriesOk(data) {

    this.loader.count--;
    this.categories = data;
    this.unifyCategories(data.masterProperties);

  }

  getCategoriesError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }


  getProjection(getProjectionIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.exhitorsService.getProjection(getProjectionIn)
      .subscribe((data: object) => {
        this.getProjectionOk(data);
      },
        error => {
          this.getProjectionError(error);
        });

  }

  getProjectionOk(data) {

    this.loader.count--;
    this.projection = data;
    this.titleService.setTitle(this.projection?.name);

  }

  getProjectionError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }


  getImages(getImagesIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.exhitorsService.getImages(getImagesIn)
      .subscribe((data: object) => {
        this.getImagesOk(data);
      },
        error => {
          this.getImagesError(error);
        });

  }

  getImagesOk(data) {

    this.loader.count--;
    if(data._embedded.images.length > 0){
      this.images = data._embedded.images;//Revisar en las otros detalles que solo llega un elemento
      this.startAutoSlide();
    }

  }

  getImagesError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  getSocialNetwork(getSocialNetworkIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.catalogueService.getSocialNetwork(getSocialNetworkIn)
      .subscribe((data: object) => {
        this.getSocialNetworkOk(data);
      },
        error => {
          this.getSocialNetworkError(error);
        });

  }

  getSocialNetworkOk(data) {

    this.loader.count--;
    this.socialNetwork = data;

  }

  getSocialNetworkError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  getFiraMaps(getFiraMapsIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.mapsService.getFiraMaps(getFiraMapsIn)
      .subscribe((data: object) => {
        this.getFiraMapsOk(data);
      },
        error => {
          this.getFiraMapsError(error);
        });

  }

  getFiraMapsOk(data) {

    this.loader.count--;
    this.firaMaps = data;

  }

  getFiraMapsError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }
  
  getOds(getOdsIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.odsService.getOds(getOdsIn)
      .subscribe((data: object) => {
        this.getOdsOk(data);
      },
        error => {
          this.getOdsError(error);
        });

  }


  getOdsOk(data) {

    this.loader.count--;
    this.ods = (data as any[]).sort((a, b) => {
      const numA = parseInt(a.name.replace('ODS_', ''), 10);
      const numB = parseInt(b.name.replace('ODS_', ''), 10);
      return numA - numB;
    });

  }

  getOdsError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;
  
  }

  getOdsActive(getOdsActiveIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.odsService.getOdsActive(getOdsActiveIn)
      .subscribe((data: object) => {
        this.getOdsActiveOk(data);
      },
        error => {
          this.getOdsActiveError(error);
        });

  }

  getOdsActiveOk(data) {

    this.loader.count--;
    this.isOdsActive = data;

  }

  getOdsActiveError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }
  
  getCatalogueAndExhibitor(getCatalogueAndExhibitorIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.searchService.getCatalogueAndExhibitor(getCatalogueAndExhibitorIn)
      .subscribe((data: object) => {
        this.getCatalogueAndExhibitorOk(data);
      },
        error => {
          this.getCatalogueAndExhibitorError(error);
        });

  }

  getCatalogueAndExhibitorOk(data) {

    this.loader.count--;
    this.files = data['_embedded']['files'];

  }

  getCatalogueAndExhibitorError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;
  
  }

  getCountriesInUse(getCountriesInUseIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.catalogueService.getCountriesInUse(getCountriesInUseIn)
      .subscribe((data: object) => {
        this.getCountriesInUseOk(data);
      },
        error => {
          this.getCountriesInUseError(error);
        });

  }

  getCountriesInUseOk(data) {

    this.loader.count--;
    this.countriesMap = {};
    data._embedded.countries.forEach(ctry => {
      this.countriesMap[ctry.id] = ctry;
      this.baseDataLoaded = true;
    });

  }

  getCountriesInUseError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;
    this.baseDataLoaded = true;

  }

  getHierarchicalProperties(getHierarchicalPropertiesIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.catalogueService.getHierarchicalProperties(getHierarchicalPropertiesIn)
      .subscribe((data: object) => {
        this.getHierarchicalPropertiesOk(data);
      },
        error => {
          this.getHierarchicalPropertiesError(error);
        });

  }

  getHierarchicalPropertiesOk(data) {

    this.loader.count--;
    this.unifyCategories(data);

  }

  getHierarchicalPropertiesError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  setMapsActive() {
    if(this.exhibitor){
      this.standData = this.utilsService.standConvertor(this.exhibitor.standLocation);
      this.mapsActive = this.catalogueService.getProperty('mapsActive') ? (this.standData.successful || this.standData.partial) : false;
      console.log(this.standData, this.exhibitor.standLocation, this.mapsActive);
    }
  }


  setFavorite(): void {
    this.isFavorite = !this.isFavorite;
  }

  showEmailForm(): void {
    // Logic to show the email form
  }

  setExhibitorImage(defaultImage: string): string {
    return defaultImage || 'assets/img/default-image.png';
  }

  exhibitorHasSocialNetworks(exhibitor: any): boolean {
    if (!!exhibitor.facebookUrl || !!exhibitor.twitterUrl || !!exhibitor.instagramUrl || !!exhibitor.googlePlusUrl || !!exhibitor.linkedInUrl || !!exhibitor.flickrUrl || !!exhibitor.pinterestUrl) {
      return true;
    }
    return false;
  }
  
  getDetailProperty(property: string): any {
    //return this.helpers.getDetailProperty(property);
    return '';
  }


  //getEmbededUrl
  getEmbededUrl(url){
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  getVideoSafeUrl(url: string): SafeResourceUrl {
    let safeUrl:SafeResourceUrl = '';

    if(this.isVimeoUrl(url)) {
      safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        this.parseVimeoUrl(url)
      );

      return safeUrl;
    }

    safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.parseSortYoutubeUrl(url)
    );

    if(url?.includes('www.youtube.com')){
      safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        this.parseYoutubeUrl(url)
      );
    }

    return safeUrl;
  }

  parseYoutubeUrl(url: string): string {
    return url.replace('www.youtube.com/watch?v=', 'www.youtube.com/embed/');
  }

  parseSortYoutubeUrl(url: string): string {
    return url.replace('youtu.be/', 'www.youtube.com/embed/');
  }

  parseVimeoUrl(url: string): any {
    return url.replace('vimeo.com/', 'player.vimeo.com/video/');
  }

  isVimeoUrl(url: string) {
    return url.includes('vimeo');
  }

  setImage(url: string) {
    return url ? url : this.catalogueProperties.defaultExhibitorImage || 'assets/img/no_image_available.png';
  }

  private readonly mapImagesByPrefix: string[] = CONSTANTS.FAIRGROUNDS_WITH_MAP_IMAGE;

  getMapImage(): string {
    const fairground = this.utilsService.getFairground(this.projection?.standLocation);
    const prefix = this.mapImagesByPrefix.find(p => p === fairground) || 'GV';
    return `assets/img/map-${prefix}.png`;
  }

  unifyCategories(categories) {
    for (let i = 0; i < categories.length; i++) {
      this.unifiedCategories.push(categories[i]);
      if (categories[i].childHierarchicalProperties) {
        this.unifyCategories(categories[i].childHierarchicalProperties);
      }
    }
  }
  
  removeExtFromUrlFile(url:string):string {
    if(url != null) {
      const fileName = url.split('/');
      return this.removeExt(fileName[fileName.length - 1]);
    } else {
      return "";
    }
  }
  
  removeExt(fileName:string):string {
    if(fileName.match(/\./)) {
        var splitted = fileName.split(".");
        splitted.pop();
        return splitted.join(".");
    }
    return fileName;
  }
  
  fixUrl(url:string):string {
    if (typeof(url) === 'string') {
        if (!url.match(/http/)) {
            return 'http://'+url;
        }
        return url;
    }
    return url;
  }

  goBack(): void {

    const searchConfig$ = this.searchService.getSearchConfig();
    
    if(this.utilsService.isEmpty(searchConfig$.brand)){
      const queryParams = { filter: 'ONLY_EXHIBITORS', lang: this.utilsService.mapLanguageCode(this.translateService.currentLang)};
      this.router.navigate([`${this.catalogueService.getProperty('eventName')}/home`], {queryParams});
    }
    else{
      const queryParams = { filter: 'ONLY_BRANDS', lang: this.utilsService.mapLanguageCode(this.translateService.currentLang)};
      this.router.navigate([`${this.catalogueService.getProperty('eventName')}/home`], {queryParams});

    }
  }

  goMap(): void {
    const queryParams = { exhibitorId: this.exhibitorId, lang: this.utilsService.mapLanguageCode(this.translateService.currentLang)};
    this.router.navigate([`${this.catalogueService.getProperty('eventName')}/firamaps`], {queryParams});
  }

  nextSlide() {
    this.currentSlideIndex = (this.currentSlideIndex + 1) % this.images.length;
    this.resetAutoSlide();
  }

  previousSlide() {
    this.currentSlideIndex =
      (this.currentSlideIndex - 1 + this.images.length) % this.images.length;
    this.resetAutoSlide();
  }

  private startAutoSlide() {
    if (this.images.length > 1) {
      this.autoSlideInterval = setInterval(() => {
        this.currentSlideIndex = (this.currentSlideIndex + 1) % this.images.length;
      }, this.AUTO_SLIDE_DELAY);
    }
  }

  private stopAutoSlide() {
    if (this.autoSlideInterval) {
      clearInterval(this.autoSlideInterval);
      this.autoSlideInterval = null;
    }
  }

  private resetAutoSlide() {
    this.stopAutoSlide();
    this.startAutoSlide();
  }

}
